import { Quill } from 'react-quill';
import { dummyCallback } from '../../utils/complexDocumentConstants';

const History = Quill.import('modules/history');
class CustomQuillHistoryModule extends History {
  constructor(quill, options) {
    super(quill, options);
    this.callback = options.callback || dummyCallback;
    this.historyCallback = options.historyCallback || dummyCallback;
    console.log({ options });
    this.customize = options.customize;
    // console.log("stack :: ", this.stack, options.itemUUID, options.editorMap);
    // TODO : Remove keyboard bindings when bringing in overall Ctrl+Z and Ctrl+Shift+Z oprations
  }

  change(source, dest) {
    super.change(source, dest);
    // TODO : These changes need not be done until quill's shorthands for undo and redo are disabled
    // Catch cases where there is no more undo / redo and block from going into context
    // On undo / redo when quill is active, sync only contents on debounced change handler
    // When quill editor is not in focus, receive triggers from context to change the contents, which again will trigger a change event
    this.callback(source);
  }

  record(changeDelta, oldDelta) {
    const oldUndoStackLength = this.stack.undo.length;
    const oldRedoStackLength = this.stack.redo.length;
    super.record(changeDelta, oldDelta);
    this.historyCallback(this.stack);
    if (this.stack.undo.length > oldUndoStackLength) {
      this.callback('record', this.stack.undo.length - oldUndoStackLength, oldRedoStackLength - this.stack.redo.length);
    }
  }

  undo() { // Disabling default undo action
    if (!this.customize) {
      super.undo();
    }
  }

  redo() { // Disabling default redo action
    if (!this.customize) {
      super.redo();
    }
  }

  setInitialStack(existingStack) {
    console.log("Setting existing stack :: ", existingStack);
    this.stack = existingStack || this.stack;
  }

  customUndo() {
    this.callback('undo');
    super.undo();
    this.historyCallback(this.stack);
  }

  customRedo() {
    this.callback('redo');
    super.redo();
    this.historyCallback(this.stack);
  }
}

export default CustomQuillHistoryModule;
